import DatePickerDialog from "@/components/DatePickerDialog/DatePickerDialog.vue";
import Utils from '@/scripts/Utils';
import { showDeleteDialogAlert } from "@/utils/DialogAlertHelper";
import Rules from "@/utils/Rules";
import { mapGetters, mapMutations, mapState } from "vuex";
import * as XLSX from 'xlsx-js-style';
var { DateTime } = require("luxon");
import ServerModensService from "@/services/server/ModensService";
import ModemModelsService from "@/services/server/ModemModelsService";
import ReadingsService from "@/services/server/ReadingsService";
import SectorsService from "@/services/server/SectorsService";
import UnitsService from "@/services/server/UnitsService";
import UsersServerService from "@/services/server/UsersService";
import { showErrorSnackBar, showSuccessSnackBar, showInfoSnackBar } from "@/utils/SnackBartHelper";



export default {
  components: {
    DatePickerDialog,
  },
  name: "Modems",

  data: () => ({
    readingsSnapashot: [],
    playTelemetryButton: false,
    telemetryRefreshSeconds: 20,
    telemetryCountdown: 20,
    telemetryCountdownIntervalId: null,
    telemetryPollTimeoutId: null,
    telemetryRequestInFlight: false,
    telemetryStatus: "idle",
    lastTelemetryReadingKey: null,
    headersTelemetry: [
      {
        text: 'Data / Hora',
        align: 'start',
        sortable: false,
        value: 'lastDate',
        width: 200
      },
      { text: 'Dados brutos', value: 'data' },
    ],
    sectorCurrentModem: {},
    sectorCurrentModemLoading: false,
    unitCurrentSector: {},
    unitCurrentSectorLoading: false,

    endDate: null,
    startDate: null,
    downloadDialog: false,
    isSaving: false,
    modemCreationFailed: false,
    isWaitingLoraResponse: false,
    modemErrorMsg: "",
    searchText: "",
    columnToSearch: "Nome",
    columnsToChoose: ["ID", "Nome", "Franqueado", "Modelo", "Bateria"],
    tabItems: ["Dados", "Alertas"],
    tabModems: null,
    loadingModens: true,
    canDeleted: false,
    canEdited: false,
    modems: [],
    dialog: false,
    dialogViewAlert: false,
    // models: [{ text: "4 Hidrômetros", value: "2" }, { text: "1 Hidrômetros", value: "3" }],
    models: [],
    modemModels: [],
    modemModelsDialog: false,
    modemModelsLoading: false,
    modemModelFormValid: true,
    modemModel: {
      id: null,
      name: "",
      observation: "",
      deviceCommunicationType: "",
      supplyOrigin: "",
    },
    modemModelHeaders: [
      { text: "Nome", value: "name" },
      { text: "Fornecedor", value: "supplyOriginLabel" },
      { text: "Tipo de Comunicação", value: "deviceCommunicationTypeLabel" },
      { text: "Quantidade", value: "quantity", width: 120 },
      { text: "Observação", value: "observation", width: 260 },
      { text: "Ações", value: "actions", width: 120, sortable: false },
    ],
    supply: [{ text: "BottumUp", value: "BOTTUMUP" }, { text: "IE Tecnologia", value: "IETECH" }],
    conectionType: [
      { text: "LoraWan", value: "LORAWAN" },
      { text: "LoRa - Gateway", value: "LORA_GATEWAY" },
      { text: "Wi-Fi", value: "WIFI" },
      { text: "LTE", value: "LTE" },
    ],
    brokerSupplyOptions: [
      { text: "NLT", value: "NLT" },
      { text: "PARLACOM", value: "PARLACOM" },
    ],
    ranks: ["Super Admin", "Admin", "Franqueado", "Cliente"],
    headers: [
      { text: "Status", value: "status", width: 120, sortable: false },
      { text: "Nome", value: "name" },
      { text: "Franqueado", value: "franchisee_name" },
      { text: "ID", value: "id", width: 200 },
      { text: "Tipo de Comunicação", value: "deviceCommunicationTypeLabel", width: 170 },
      { text: "Ativo", value: "isActive", width: 100, sortable: false },
      { text: "Bateria (%)", value: "lastBattery", width: 100 },
        { text: "Última Leitura", value: "lastReadingDateSort", width: 190 },
        { text: "Última Variação", value: "lastVariationAtSort", width: 190 },
      { text: "Último Dado", value: "lastData", width: 140 },
      { text: "Ações", value: "actions", width: 100, sortable: false },
    ],
    page: 1,
    stateHistory: [],
    indexAlertPeriod: null,
    modem: {
      name: "",
      unit: "",
      id: "",
      model_id: "",
      lastReading: "",
      lastData: "",
      sectors: "",
      bateria: "",
      id_franchisee: "",
      isActive: true,
    },
    validForm: true,
    modemIndex: -1,
    listFranchisees: [],
    franchiseeSelected: null,
    modalTitle: '',
    modalFlag: false,
    isEditingModem: false,
    editingModemCommunicationType: "",
    beforeState: null,
    currentState: null,
    modalDeleteBody: '',
    modalDelete: false,
    leituras: [],
    pagePerDocSnapshot: { 0: null },
    paginationInfo: {
      pageCount: 1,
      lastDocSnapshot: null,
      penultimateDocSnapshot: null,
      totalDocs: 0,
      length: 100,
      list: [],
      pageList: [],
      loading: true
    },
    processingItem: null,
    getModems: [],
    listActions: [
      { value: "edit", title: "Editar"},
      { value: "download", title: "Log"},
      { value: "delete", title: "Excluir"},
    ]
  }),

  methods: {
    ...mapMutations(["SET_MODEMS"]),
    async generateID() {
      const response = await ServerModensService.generateId()
      this.modem.id = response?.data?.data || ""
    },
    normalizeModemModel(model) {
      return {
        ...model,
        deviceCommunicationTypeLabel: this.getConnectionType(model.deviceCommunicationType),
        supplyOriginLabel: this.getSupplyLabel(model.supplyOrigin),
      };
    },
    setModemModels(modemModels = []) {
      this.modemModels = modemModels.map((model) => this.normalizeModemModel(model));
      this.models = this.modemModels.map((model) => ({
        text: `${model.name} - ${this.getConnectionType(model.deviceCommunicationType)}`,
        value: model.id,
      }));
      if (this.getModems?.length) this.enrichModemsList();
    },
    async loadModemModels() {
      this.modemModelsLoading = true;
      try {
        const response = await ModemModelsService.findAll();
        this.setModemModels(response?.data?.data || []);
      } catch (error) {
        console.error(error);
        showErrorSnackBar("Erro ao buscar modelos de modem.");
      } finally {
        this.modemModelsLoading = false;
      }
    },
    resetModemModelForm() {
      this.modemModel = {
        id: null,
        name: "",
        observation: "",
        deviceCommunicationType: "",
        supplyOrigin: "",
      };
      if (this.$refs.ModemModelForm) this.$refs.ModemModelForm.resetValidation();
    },
    openModemModelsDialog() {
      this.modemModelsDialog = true;
      this.loadModemModels();
    },
    editModemModel(model) {
      this.modemModel = {
        id: model.id,
        name: model.name || "",
        observation: model.observation || "",
        deviceCommunicationType: model.deviceCommunicationType || "",
        supplyOrigin: model.supplyOrigin || "",
        quantity: model.quantity || 0,
      };
      if (this.$refs.ModemModelForm) this.$refs.ModemModelForm.resetValidation();
    },
    onModemModelSupplyOriginChange() {
      const allowedTypes = this.getConnectionTypesForSupplyOrigin(this.modemModel.supplyOrigin);
      if (
        this.modemModel.deviceCommunicationType
        && !allowedTypes.some((type) => type.value === this.modemModel.deviceCommunicationType)
      ) {
        this.modemModel.deviceCommunicationType = "";
      }
    },
    buildModemModelPayload() {
      const { name, observation, deviceCommunicationType, supplyOrigin } = this.modemModel;
      return { name, observation, deviceCommunicationType, supplyOrigin };
    },
    async saveModemModel() {
      if (this.$refs.ModemModelForm && !this.$refs.ModemModelForm.validate()) return;
      this.modemModelsLoading = true;
      try {
        const isEditing = Boolean(this.modemModel.id);
        const payload = this.buildModemModelPayload();
        const response = isEditing
          ? await ModemModelsService.update(this.modemModel.id, payload)
          : await ModemModelsService.create(payload);
        const saved = response?.data?.data;
        if (saved) {
          const nextModels = isEditing
            ? this.modemModels.map((model) => model.id === saved.id ? saved : model)
            : [...this.modemModels, saved];
          this.setModemModels(nextModels);
          this.resetModemModelForm();
        } else {
          await this.loadModemModels();
        }
        showSuccessSnackBar(isEditing ? "Modelo de modem atualizado com sucesso!" : "Modelo de modem cadastrado com sucesso!");
      } catch (error) {
        console.error(error);
      } finally {
        this.modemModelsLoading = false;
      }
    },
    confirmDeleteModemModel(model) {
      showDeleteDialogAlert(
        `Deseja excluir o modelo ${model.name}?`,
        () => this.deleteModemModel(model)
      );
    },
    async deleteModemModel(model) {
      this.modemModelsLoading = true;
      try {
        await ModemModelsService.hardDelete(model.id);
        this.setModemModels(this.modemModels.filter((item) => item.id !== model.id));
        showSuccessSnackBar("Modelo de modem excluido com sucesso!");
      } catch (error) {
        console.error(error);
      } finally {
        this.modemModelsLoading = false;
      }
    },
    getSelectedModemModel(modelId = this.modem.model_id) {
      return this.modemModels.find((model) => model.id === modelId);
    },
    onModemModelChange(modelId) {
      const selectedModel = this.getSelectedModemModel(modelId);
      if (!selectedModel) return;
      this.$set(this.modem, "model_id", selectedModel.id);
      this.syncCommunicationTypeFields();
    },
    getModemModelForModem(modem = this.modem) {
      return this.getSelectedModemModel(modem.model_id);
    },
    getModemSupplyOrigin(modem = this.modem) {
      return this.getModemModelForModem(modem)?.supplyOrigin || "";
    },
    getModemDeviceCommunicationType(modem = this.modem) {
      return this.getModemModelForModem(modem)?.deviceCommunicationType || "";
    },
    enrichModemsList() {
      this.getModems.forEach((item) => {
        const franchisee = this.listFranchisees.find(
          (franchisee) => franchisee.id === item.id_franchisee
        );
        item.franchisee_name = franchisee ? franchisee.name : null;
        item.deviceCommunicationTypeLabel = this.getConnectionType(this.getModemDeviceCommunicationType(item));
      });
    },
    selectAction(item, value) {
      
      switch (value) {
        case "edit":
          this.FSM_Modem('edit', { modem: item })
          break;
        case "delete":
          this.FSM_Modem('delete', { modem: item })
          break;
        case "download":
          this.processingItem = item;
          this.exportSheets('xlsx', item.name, item)
          setTimeout(() => {
            this.processingItem = null;
          }, 3000)

          break;
        default:
          break;
      }
    },
    getStatusColor(lastReading) {
      if (lastReading) {
        var date = DateTime.fromJSDate(new Date(lastReading.split(" ")[0].split("/").reverse().join("/") + " " + lastReading.split(" ")[1]))
        var dateDiff = date.setLocale('pt-br').diffNow(['weeks', 'days', 'hours']).toObject()
        if (dateDiff.weeks != 0) {
          return "red";
        } else if (dateDiff.days != 0) {
          return "yellow";
        } else if (dateDiff.hours != 0) {
          return "green";
        }
      } else return "red";
    },
    getDateVariation(lastVariation) {
      if (lastVariation) {
        let date = this.parseFirestoreDate(lastVariation)
        if (!date) return "Sem Dados"
        date = Utils.formatDateDayJs(date, "DD/MM/YYYY [às] <HH>:<mm>:<ss>")
        return "Última data: " + date
      } else return "Sem Dados"
    },
    getStatusVariationColor(lastVariation) {
      if (lastVariation) {

        const parsedDate = this.parseFirestoreDate(lastVariation)
        if (!parsedDate) return "red";
        var date = DateTime.fromJSDate(parsedDate)
        var dateDiff = date.setLocale('pt-br').diffNow(['weeks', 'days', 'hours']).toObject()
        if (dateDiff.weeks != 0) {
          return "red";
        } else if (dateDiff.days != 0) {
          return "yellow";
        } else if (dateDiff.hours != 0) {
          return "green";
        }
      } else return "red";
    },
    getStatusDecodingColor(lastVariation) {
      if (lastVariation) {

        const parsedDate = this.parseFirestoreDate(lastVariation)
        if (!parsedDate) return "red";
        var date = DateTime.fromJSDate(parsedDate)
        var dateDiff = date.setLocale('pt-br').diffNow(['weeks', 'days', 'hours']).toObject()
        if (dateDiff.weeks != 0) {
          return "green";
        } else if (dateDiff.days != 0) {
          return "yellow";
        } else if (dateDiff.hours != 0) {
          return "red";
        }
      } else return "green";
    },
    getModelo(modelId) {
      const model = this.modemModels.find((item) => item.id === modelId);
      return model ? model.name : "";
    },
    getConnectionType(value) {
      const type = this.conectionType.find((connectionType) => connectionType.value === value);
      return type ? type.text : '';
    },
    getSupplyLabel(value) {
      const supply = this.supply.find((item) => item.value === value);
      return supply ? supply.text : '';
    },
    getConnectionTypesForSupplyOrigin(supplyOrigin) {
      const allowedBySupplyOrigin = {
        BOTTUMUP: ["LORAWAN", "LORA_GATEWAY", "LTE"],
        IETECH: ["WIFI", "LTE"],
      };
      const allowedTypes = allowedBySupplyOrigin[supplyOrigin] || [];
      return this.conectionType.filter((type) => allowedTypes.includes(type.value));
    },

    addHistory(state) {
      this.stateHistory.push(state.toLowerCase());
    },

    clearHistory() {
      if (this.stateHistory.length > 1) {
        this.stateHistory = this.stateHistory.splice(this.stateHistory.length - 1, 1);
      }
    },

    hasHistory(state) {
      if (this.stateHistory.length <= 0) return false;
      return this.stateHistory.includes(state.toLowerCase());
    },

    getLastHistory() {
      if (this.stateHistory.length <= 0) return null;
      return this.stateHistory[this.stateHistory.length - 1];
    },
    getTelemetryReadingKey(reading) {
      if (!reading) return null;
      if (reading.doc_id) return reading.doc_id;

      const date = this.parseFirestoreDate(reading.datetime);
      return `${reading.origin || this.modem?.id || "modem"}-${date ? date.getTime() : "no-date"}`;
    },
    buildTelemetryRow(reading) {
      if (!reading) return null;
      const lastReadingDate = this.parseFirestoreDate(reading.datetime);
      return {
        lastDate: lastReadingDate ? Utils.formatDateDayJs(lastReadingDate, "dd-MM-YYYY [as] HH:mm:ss") : "",
        data: JSON.stringify({ ...reading }),
      };
    },
    pushTelemetryReading(reading) {
      const readingKey = this.getTelemetryReadingKey(reading);
      if (!readingKey || readingKey === this.lastTelemetryReadingKey) return;

      const telemetryRow = this.buildTelemetryRow(reading);
      if (!telemetryRow) return;

      this.lastTelemetryReadingKey = readingKey;
      this.readingsSnapashot.unshift(telemetryRow);
      if (this.readingsSnapashot.length > 50) {
        this.readingsSnapashot = this.readingsSnapashot.slice(0, 50);
      }
    },
    clearTelemetryPolling(resetVisualState = true) {
      if (this.telemetryCountdownIntervalId) {
        clearInterval(this.telemetryCountdownIntervalId);
        this.telemetryCountdownIntervalId = null;
      }
      if (this.telemetryPollTimeoutId) {
        clearTimeout(this.telemetryPollTimeoutId);
        this.telemetryPollTimeoutId = null;
      }
      this.telemetryRequestInFlight = false;

      if (resetVisualState) {
        this.playTelemetryButton = false;
        this.telemetryStatus = "idle";
        this.telemetryCountdown = this.telemetryRefreshSeconds;
      }
    },
    scheduleNextTelemetryFetch() {
      if (!this.playTelemetryButton) return;

      this.telemetryCountdown = this.telemetryRefreshSeconds;
      this.telemetryStatus = "countdown";

      if (this.telemetryCountdownIntervalId) clearInterval(this.telemetryCountdownIntervalId);
      this.telemetryCountdownIntervalId = setInterval(() => {
        if (!this.playTelemetryButton) {
          this.clearTelemetryPolling();
          return;
        }
        if (this.telemetryCountdown > 0) this.telemetryCountdown -= 1;
      }, 1000);

      if (this.telemetryPollTimeoutId) clearTimeout(this.telemetryPollTimeoutId);
      this.telemetryPollTimeoutId = setTimeout(() => {
        this.fetchTelemetrySnapshot();
      }, this.telemetryRefreshSeconds * 1000);
    },
    async fetchTelemetrySnapshot() {
      if (!this.playTelemetryButton || this.telemetryRequestInFlight) return;

      this.telemetryRequestInFlight = true;
      this.telemetryStatus = "refreshing";

      try {
        const response = await ReadingsService.telemetryByModem(this.modem.id);
        const telemetry = response?.data?.data || {};

        if (telemetry.modem) {
          const normalizedTelemetryModem = this.normalizeModemDateFields(telemetry.modem);
          this.modem = normalizedTelemetryModem;
        }

        if (telemetry.latestReading) {
          this.pushTelemetryReading(telemetry.latestReading);
        }

        if (this.playTelemetryButton) {
          this.scheduleNextTelemetryFetch();
        }
      } catch (error) {
        console.error(error);
        this.telemetryStatus = "error";
        if (this.playTelemetryButton) {
          this.scheduleNextTelemetryFetch();
        }
      } finally {
        this.telemetryRequestInFlight = false;
      }
    },
    parseFirestoreDate(value) {
      if (!value) return null;
      if (value instanceof Date) return value;

      const seconds = value.seconds ?? value._seconds;
      const nanoseconds = value.nanoseconds ?? value._nanoseconds ?? 0;

      if (seconds != null) {
        return new Date(seconds * 1000 + nanoseconds / 1000000);
      }

      const parsedDate = new Date(value);
      return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
    },
    normalizeTimestampShape(value) {
      if (!value || value instanceof Date) return value;

      const seconds = value.seconds ?? value._seconds;
      const nanoseconds = value.nanoseconds ?? value._nanoseconds ?? 0;

      if (seconds == null) return value;

      return {
        seconds,
        nanoseconds,
      };
    },
    normalizeModemDateFields(modem = {}) {
      const normalizedModem = { ...modem };
      ["lastReadingDate", "lastVariationAt", "lastErrorDecodingAt", "createdAt", "updatedAt"].forEach((field) => {
        if (!Object.prototype.hasOwnProperty.call(normalizedModem, field)) return;
        normalizedModem[field] = this.normalizeTimestampShape(normalizedModem[field]);
      });
      normalizedModem.lastReadingDateSort = this.getTimestampSortValue(normalizedModem.lastReadingDate);
      normalizedModem.lastVariationAtSort = this.getTimestampSortValue(normalizedModem.lastVariationAt);
      return normalizedModem;
    },
    normalizeModemsCollection(modems = []) {
      return modems.map((modem) => this.normalizeModemDateFields(modem));
    },
    getTimestampSortValue(value) {
      const parsedDate = this.parseFirestoreDate(value);
      return parsedDate ? parsedDate.getTime() : null;
    },
    sanitizeModemPayloadForRequest(modem = {}) {
      const payload = { ...modem };
      delete payload.lastReadingDateSort;
      delete payload.lastVariationAtSort;
      delete payload.model;
      delete payload.deviceCommunicationType;
      delete payload.supplyOrigin;
      return payload;
    },
    getModemRequestData(modem = {}) {
      return {
        payload: this.sanitizeModemPayloadForRequest(modem),
        deviceCommunicationType: this.getModemDeviceCommunicationType(modem),
      };
    },
    getRequestErrorMessage(error) {
      return error?.response?.data?.message
        || error?.response?.data?.cause
        || error?.response?.data?.error
        || error?.message
        || "Erro inesperado.";
    },
    formatDateTime(value) {
      const date = this.parseFirestoreDate(value);
      if (!date) return null;

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },
    stringDate(item) {
      return this.formatDateTime(item.lastReadingDate) || item.lastReading // old object key
    },
    stringDateVariation(item) {
      return this.formatDateTime(item.lastVariationAt) || item.lastVariationAt // old object key
    },
    // Helper functions to get raw Date objects for Excel export
    getRawDate(item) {
      return this.parseFirestoreDate(item.lastReadingDate);
    },
    getRawDateVariation(item) {
      return this.parseFirestoreDate(item.lastVariationAt);
    },
    checarBateria(modem) {
      if (modem.lastBattery) return this.bateryConvert(modem.lastBattery)
      else return 0
    },
    bateryConvert(batery) {
      batery = ((batery - 20) * 100) / 12
      if (batery < 0) return 0
      else return batery.toFixed(0)
    },
    
    async exportSheets(type, name, modem) {

      let leituras = await this.buscarLeituras(modem.id)
      const isLteModem = this.getModemDeviceCommunicationType(modem) === "LTE";

      var wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "SheetJS Tutorial",
        Subject: "Test",
        Author: "Red Stapler",
        CreatedDate: new Date(2017, 12, 19)
      };
      wb.SheetNames.push("Log");
      if (isLteModem) {
        const lteHeaders = this.getLteLogHeaders(leituras);
        var ws_data = [[name],
        ['Data', 'Bateria', ...lteHeaders],
        ];
      } else {
        var ws_data = [[name],
        ['Data', 'Bateria', 'Leitura 1', 'Leitura 2', 'Leitura 3', 'Leitura 4'],
        ];
      }

      for (let key in leituras) {
        if (isLteModem) {
          const ltePayload = leituras[key].lte || {};
          const lteHeaders = ws_data[1].slice(2);
          const battery = this.getLteReadingBattery(leituras[key], modem);
          const y = this.getReadingDate(leituras[key].datetime)
          ws_data.push([
            Utils.formatDateDayJs(y, "DD/MM/YYYY [às] HH:mm:ss"),
            battery,
            ...lteHeaders.map((header) => this.formatLogValue(ltePayload[header]))
          ])
          continue;
        }


        let decodedResult = ["Esse modem está com formato maior que 18 bytes", null, null, null]
        let decoded = leituras[key].decoded
        if (!Array.isArray(decoded)) continue;
        if (decoded.length <= 18) decodedResult = this.convertByteToDecimal(decoded)


        let datetime = leituras[key].datetime
        let batery = decoded[1]
        let y = null
        y = this.parseFirestoreDate(datetime)

        ws_data.push([Utils.formatDateDayJs(y, "DD/MM/YYYY [às] HH:mm:ss"),
          this.bateryConvert(batery) + "%",
          decodedResult[0],
          decodedResult[1],
          decodedResult[2],
          decodedResult[3]])

      }

      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      var wscols = [
        { wch: 22 }
      ];
      ws['!cols'] = wscols;

      wb.Sheets["Log"] = ws;

      setTimeout(() => {
        XLSX.writeFile(wb, name + ".xlsx");
      }, 2000)

    },
    getReadingDate(datetime) {
      return this.parseFirestoreDate(datetime) || new Date()
    },
    getLteLogHeaders(readings) {
      const keys = []
      readings.forEach((reading) => {
        const payload = reading.lte || {}
        Object.keys(payload).forEach((key) => {
          if (!this.isIgnoredLteLogHeader(key) && !keys.includes(key)) keys.push(key)
        })
      })
      return keys
    },
    isIgnoredLteLogHeader(key) {
      const normalizedKey = String(key || "").toLowerCase()
      const ignoredHeaders = ["conn_time", "rssi", "tech", "ver", "batt", "lastbattery", "iccid", "txtime"]
      return ignoredHeaders.includes(normalizedKey) || normalizedKey.includes("lastdata")
    },
    getLteReadingBattery(reading, modem) {
      const payload = reading.lte || {}
      const battery = payload.Batt || payload.BATT || payload.batt || payload.BAT || payload.bat || payload.lastBattery || reading.lastBattery || modem.lastBattery
      if (battery === undefined || battery === null || battery === "") return "Sem dados"
      const batteryVoltage = Number(battery) / 1000
      return Number.isFinite(batteryVoltage) ? `${batteryVoltage}V` : "Sem dados"
    },
    formatLogValue(value) {
      if (value === undefined || value === null) return null
      if (typeof value === "object") return JSON.stringify(value)
      return value
    },
    async generateReport() {
      try {
        // Mostrar loading
        this.loadingModens = true;
        
        // Preparar dados para o relatório
        const reportData = this.filteredItems.map(modem => ({
          'Nome': modem.name || '',
          'Franqueado': modem.franchisee_name || '',
          'ID': modem.id || '',
          'Modelo': this.getModelo(modem.model_id) || '',
          'Status': (modem.isActive !== false) ? 'Ativado' : 'Desativado',
          'Bateria (%)': this.checarBateria(modem) || '',
          'Última Leitura': this.getRawDate(modem) || 'Sem leituras',
          'Última Variação': this.getRawDateVariation(modem) || 'Sem variações',
          'Último Dado': modem.lastData || 'Sem dados',
          'Fornecedor': this.getSupplyLabel(this.getModemSupplyOrigin(modem)) || '',
          'Tipo de Conexão': this.getConnectionType(this.getModemDeviceCommunicationType(modem)) || ''
        }));

        // Criar workbook
        const wb = XLSX.utils.book_new();
        wb.Props = {
          Title: "Relatório de Modems",
          Subject: "Relatório completo de modems",
          Author: "Sistema FOZ",
          CreatedDate: new Date()
        };

        // Criar worksheet
        const ws = XLSX.utils.json_to_sheet(reportData);

        // Configurar largura das colunas
        const wscols = [
          { wch: 20 }, // Nome
          { wch: 20 }, // Franqueado
          { wch: 15 }, // ID
          { wch: 15 }, // Modelo
          { wch: 12 }, // Status
          { wch: 12 }, // Bateria
          { wch: 20 }, // Última Leitura
          { wch: 20 }, // Última Variação
          { wch: 15 }, // Último Dado
          { wch: 15 }, // Fornecedor
          { wch: 15 }  // Tipo de Conexão
        ];
        ws['!cols'] = wscols;

        // Adicionar worksheet ao workbook
        XLSX.utils.book_append_sheet(wb, ws, "Modems");

        // Gerar nome do arquivo com data
        const now = new Date();
        const dateStr = now.toISOString().split('T')[0]; // YYYY-MM-DD
        const fileName = `relatorio_modems_${dateStr}.xlsx`;

        // Download do arquivo
        XLSX.writeFile(wb, fileName);

        // Mostrar mensagem de sucesso
        showSuccessSnackBar("Relatório gerado com sucesso!");
        
      } catch (error) {
        console.error('Erro ao gerar relatório:', error);
        showErrorSnackBar("Erro ao gerar relatório. Tente novamente.");
      } finally {
        this.loadingModens = false;
      }
    },
    async buscarLeituras(modemId) {

      const response = await ReadingsService.byModem(modemId);
      return response?.data?.data || [];

    },
    convertByteToDecimal(decoded) {
      let a, b, c, d, j = 0
      let result = []
      let decodedPort = []
      for (let i = 0; i < 4; i++) {

        a = decoded[2 + j]
        b = decoded[3 + j]
        c = decoded[4 + j]
        d = decoded[5 + j]
        j += 4

        decodedPort.push(a, b, c, d)
        decodedPort = new Uint8Array(decodedPort);
        decodedPort = new DataView(decodedPort.buffer, 0);

        let soma = decodedPort.getUint32(0)
        result.push(soma)
        decodedPort = []
      }

      return result;
    },
    async FSM_Modem(state = 'edit', params = {}) {


      let modem, index, title, modems;

      this.addHistory(state.toLowerCase());

      switch (this.getLastHistory()) {

        case 'create':
          this.clearHistory();
          this.isEditingModem = false;
          this.editingModemCommunicationType = "";
          this.modemCreationFailed = false;
          modem = {
            name: "",
            id: "",
            model_id: "",
            lastReading: "",
            lastData: "",
            sectors: "",
            id_franchisee: "",
            isActive: true,
          };
          index = -1;
          title = 'Cadastro de Modem';
          this.FSM_Modem('open-modal', { modem, index, title });
          break;

        case 'edit':
          this.clearHistory();
          this.isEditingModem = true;
          this.modemCreationFailed = false;
          this.hasArguments(['modem'], params);
          // index = params.index;
          modem = params.modem;
          index = this.paginationInfo.pageList.findIndex((m) => m.id === modem.id);
          title = 'Edição de Modem';
          await ServerModensService.getById(modem.id)
            .then(res => {
              const modemData = this.normalizeModemDateFields(res?.data?.data || {});
              if (modemData) {
                for (let key in modemData) {
                  modem[key] = modemData[key];
                }
                this.FSM_Modem('open-modal', { modem, index, title });
              } else {
                this.FSM_Modem('close-modal');
              }
            })
            .catch(err => {
              console.error(err);
            })
          break;

        case 'delete':
          this.clearHistory();

          this.hasArguments(['modem'], params);
          // index = params.index;
          modem = params.modem;
          index = this.getModems.findIndex((m) => m.id === modem.id);
          this.FSM_Modem('open-delete-modal', { modem, index });
          break;

        case 'open-delete-modal':
          this.hasArguments(['index', 'modem'], params);
          this.modem = params.modem;
          this.modemIndex = params.index;
          this.modalDeleteBody = `Tem certeza que deseja remover o modem ${this.modem.name}?`;
          showDeleteDialogAlert(`Deseja excluir o modem "${this.modem.name}"`, this.deleteModem)
          break;

        case 'close-delete-modal':
          this.modalDelete = false;
          break;

        case 'open-modal':
          this.clearTelemetryPolling()
          this.readingsSnapashot = []
          this.lastTelemetryReadingKey = null
          this.hasArguments(['modem', 'index', 'title'], params);
          this.modem = params.modem;
          const modalDeviceCommunicationType = this.getModemDeviceCommunicationType(this.modem);
          this.editingModemCommunicationType = this.isEditingModem
            ? modalDeviceCommunicationType
            : "";
          if (
            (modalDeviceCommunicationType === "LORAWAN" ||
              modalDeviceCommunicationType === "LTE") &&
            !this.modem.brokerSupply
          ) {
            this.$set(this.modem, "brokerSupply", "NLT");
          }
          this.syncCommunicationTypeFields();

          if (params.title === 'Edição de Modem') {
            // tabItems
            this.getSector(this.modem.id)
            this.tabItems = ["Dados", "Alertas", "Telemetria"]
          }

          this.modemIndex = params.index;
          this.modalTitle = params.title;
          this.modalFlag = true;

          break;

        case 'close-modal':
          this.clearTelemetryPolling()
          this.tabItems = ["Dados", "Alertas"]
          this.modalFlag = false;
          this.editingModemCommunicationType = "";
          this.sectorCurrentModem = {}
          this.unitCurrentSector = {}
          break;

        case 'accept-delete-modal':
          this.hasArguments(['modem', 'index'], params);
          modem = params.modem;
          index = params.index;
          this.modalDelete = false;
          this.FSM_Modem('delete-modem', { modem, index });
          break;

        case 'save-modal':
          if (this.$refs.FormModem && !this.$refs.FormModem.validate()) return;
          this.hasArguments(['modem', 'index'], params);

          modem = params.modem;
          index = params.index;
          var error = false;
          this.modemCreationFailed = false;
          if (modem.id_franchisee === undefined) {
            showErrorSnackBar("Informar o franqueado é obrigatório! Modem não salvo!");
            break;
          }
            this.isSaving = true;
            try {
              const saveDeviceCommunicationType = this.getModemDeviceCommunicationType(modem);
              if (saveDeviceCommunicationType === "WIFI") {
                if (this.hasHistory('create')) {
                  await this.FSM_Modem('add-modem', { modem });
                } else if (this.hasHistory('edit')) {
                  await this.FSM_Modem('update-modem', { modem, index });
                }
            } else if (saveDeviceCommunicationType === "LTE") {
              if (!this.validateLteModem(modem)) {
                this.isSaving = false;
                this.modemCreationFailed = true;
                this.modemErrorMsg = this.lteImeiErrorMessage();
                showErrorSnackBar(this.lteImeiErrorMessage());
                break;
              }
              if (!this.validateBrokerSupply(modem)) {
                this.isSaving = false;
                showErrorSnackBar("Selecione o fornecedor broker (NLT ou PARLACOM).");
                break;
              }
              if (this.hasHistory('create')) {
                await this.FSM_Modem('add-modem', { modem });
              } else if (this.hasHistory('edit')) {
                await this.FSM_Modem('update-modem', { modem, index });
              }
            } else if (saveDeviceCommunicationType === "LORAWAN") {
              if (!this.validateLoraWanModemId(modem)) {
                this.isSaving = false;
                this.modemCreationFailed = true;
                this.modemErrorMsg = this.loraWanModemIdErrorMessage();
                showErrorSnackBar(this.loraWanModemIdErrorMessage());
                break;
              }
              if (!this.validateBrokerSupply(modem)) {
                this.isSaving = false;
                showErrorSnackBar("Selecione o fornecedor broker (NLT ou PARLACOM).");
                break;
              }
              if (this.hasHistory('create')) {
                await this.FSM_Modem('add-modem', { modem });
              } else if (this.hasHistory('edit')) {
                await this.FSM_Modem('update-modem', { modem, index });
              }
            } else if (saveDeviceCommunicationType === "LORA_GATEWAY") {
              if (!this.validateLoraGatewayModemId(modem)) {
                this.isSaving = false;
                this.modemCreationFailed = true;
                this.modemErrorMsg = this.loraGatewayModemIdErrorMessage();
                showErrorSnackBar(this.loraGatewayModemIdErrorMessage());
                break;
              }
              if (this.hasHistory('create')) {
                await this.FSM_Modem('add-modem', { modem });
              } else if (this.hasHistory('edit')) {
                await this.FSM_Modem('update-modem', { modem, index });
              }
            }
            this.isSaving = false;
            showSuccessSnackBar("Modem salvo com sucesso!");
          } catch (e) {
            console.error(e);
            error = true;
            if (!this.modemCreationFailed) {
              showErrorSnackBar("Aconteceu um erro inesperado, contacte o suporte!");
            }
          }

          if (error) {
            this.modalFlag = true;
          } else {
            this.modalFlag = false;
          }
          break;

        case 'add-modem':
          this.hasArguments(['modem'], params);
          this.loadingModens = true
          modem = params.modem;
          modems = this.getModems;
          var error = false;
            this.isWaitingLoraResponse = true;
            this.modemErrorMsg = "";
            const { payload: modemData, deviceCommunicationType: addDeviceCommunicationType } = this.getModemRequestData(modem);
            let registerPromise;
            if (["LTE", "WIFI"].includes(addDeviceCommunicationType)) {
              if (modemData.id) {
                modemData.id = String(modemData.id).trim();
              }
              if (!modemData.sectors || typeof modemData.sectors !== "object") {
                modemData.sectors = {};
              }
              registerPromise = ServerModensService.registerLocal(modemData);
            } else if (addDeviceCommunicationType === "LORA_GATEWAY") {
              if (modemData.id) {
                modemData.id = String(modemData.id).trim();
              }
              if (!modemData.sectors || typeof modemData.sectors !== "object") {
                modemData.sectors = {};
              }
              registerPromise = ServerModensService.registerInternal(modemData);
            } else if (addDeviceCommunicationType === "LORAWAN") {
              if (modemData.id) {
                modemData.id = modemData.id.trim().toLowerCase();
              }
              registerPromise = ServerModensService.registerLorawan(modemData);
            } else {
              throw new Error("Tipo de comunicação inválido para cadastro de modem.");
            }

            await registerPromise
            .then((response) => {
              modem = response?.data?.data || modemData;
            })
            .catch((e) => {
              this.isWaitingLoraResponse = false;
              this.isSaving = false;
              const errorMsg = this.getRequestErrorMessage(e);
              console.error(errorMsg);
              this.modemCreationFailed = true;
              if (addDeviceCommunicationType === "LTE") {
                if (String(errorMsg).includes("already exists")) {
                  this.modemErrorMsg = "Este IMEI já está cadastrado.";
                } else if (String(errorMsg).toLowerCase().includes("imei")) {
                  this.modemErrorMsg = this.lteImeiErrorMessage();
                } else {
                  this.modemErrorMsg = "Não foi possível cadastrar o modem LTE.";
                }
              } else if (addDeviceCommunicationType === "WIFI") {
                if (String(errorMsg).includes("already exists")) {
                  this.modemErrorMsg = "Este ID já está cadastrado.";
                } else {
                  this.modemErrorMsg = "Não foi possível cadastrar o modem Wi-Fi.";
                }
              } else if (addDeviceCommunicationType === "LORA_GATEWAY") {
                if (String(errorMsg).includes("already exists")) {
                  this.modemErrorMsg = "Já existe um modem cadastrado com este DevAddr.";
                } else if (/DevEUI|DevAddr/i.test(String(errorMsg))) {
                  this.modemErrorMsg = this.loraGatewayModemIdErrorMessage();
                } else {
                  this.modemErrorMsg = errorMsg;
                }
              } else {
                switch (errorMsg) {
                case 'token error':
                  this.modemErrorMsg = 'Credenciais inválidas ao cadastrar na LoRa.';
                  break;
                case 'creation error':
                  this.modemErrorMsg = 'Não foi possivel criar modem na LoRa.';
                  break;
                case 'activation error':
                  this.modemErrorMsg = 'Não foi possivel ativar modem na LoRa.';
                  break;
                case 'invalid brokerSupply':
                  this.modemErrorMsg = 'Selecione um fornecedor broker válido (NLT ou PARLACOM).';
                  break;
                default:
                  this.modemErrorMsg = errorMsg;
                  break;
              }
            }
            throw new Error(errorMsg);
          }).finally(() => {
            this.loadingModens = false
            this.isSaving = false;
          })
          this.isWaitingLoraResponse = false;
          modems.unshift(modem);
          this.enrichModemsList();
          break;

        case 'update-modem':
          if (this.canEdited) {
            this.hasArguments(['modem', 'index'], params);
            this.loadingModens = true;
            index = params.index;
            modem = params.modem;
            modems = this.getModems;
            modems[index] = modem;
              this.enrichModemsList();
              //update setor e modem correspondente da unidade
              let updatePromise;
              const { payload: modemPayload, deviceCommunicationType: updateDeviceCommunicationType } = this.getModemRequestData(modem);
              if (["LTE", "WIFI", "LORA_GATEWAY"].includes(updateDeviceCommunicationType)) {
                updatePromise = ServerModensService.updateLocal(modem.id, modemPayload);
              } else if (updateDeviceCommunicationType === "LORAWAN") {
                updatePromise = ServerModensService.updateLorawan(modem.id, modemPayload);
              } else {
                throw new Error("Tipo de comunicação inválido para edição de modem.");
              }
              await updatePromise
            .finally(() => {
            this.loadingModens = false
            this.isSaving = false;
          })
          this.FSM_Modem('set-modems', { modems })
          }
          break;

        case 'delete-modem':
          if (this.canDeleted) {
            this.hasArguments(['modem', 'index'], params);
            this.loadingModens = true;
            index = params.index;
            modem = params.modem;
            modems = this.getModems;

              let deletePromise;
              const deleteDeviceCommunicationType = this.getModemDeviceCommunicationType(modem);
              if (["LTE", "WIFI", "LORA_GATEWAY"].includes(deleteDeviceCommunicationType)) {
                deletePromise = ServerModensService.deleteLocal(modem.id);
              } else if (deleteDeviceCommunicationType === "LORAWAN") {
                deletePromise = ServerModensService.deleteLorawan(modem.id);
              } else {
                throw new Error("Tipo de comunicação inválido para exclusão de modem.");
              }
              await deletePromise
            .then(() => {
              modems.splice(index, 1);
              this.FSM_Modem('set-modems', { modems })
            })
            .catch(err => console.error(err))
            .finally(() => this.loadingModens = false)
          }
          break;
          
          case 'set-modems':
          this.hasArguments(['modems'], params);
          modems = params.modems;
          // this.SET_MODEMS(modems);
          this.loadingModens = false;
          break;

      }

    },
    async getSector(modemId) {
      this.sectorCurrentModemLoading = true

      const resSectorResponse = await SectorsService.findByModem(modemId)
      const resSector = resSectorResponse?.data?.data || []
      if (resSector.length) {
        this.sectorCurrentModemLoading = false
        this.sectorCurrentModem = resSector[0]
        this.unitCurrentSectorLoading = true
        UnitsService.getUnitById(this.sectorCurrentModem.id_unit)
          .then(res => this.unitCurrentSector = res?.data?.data || {})
          .finally(() => {
            this.unitCurrentSectorLoading = false
          })
      } else {
        this.sectorCurrentModemLoading = false
      }

    },
    startListenerData() {
      if (this.playTelemetryButton) {
        this.clearTelemetryPolling();
        return;
      }

      this.playTelemetryButton = true
      this.telemetryStatus = "refreshing";
      this.telemetryCountdown = this.telemetryRefreshSeconds;
      this.fetchTelemetrySnapshot();
    },
    async deleteModem() {
      this.loadingModens = true;
      let modem = this.modem;
      let index = this.modemIndex;
      let modems = this.getModems;

      try {
        let deletePromise;
        const deviceCommunicationType = this.getModemDeviceCommunicationType(modem);
        if (["LTE", "WIFI", "LORA_GATEWAY"].includes(deviceCommunicationType)) {
          deletePromise = ServerModensService.deleteLocal(modem.id);
        } else if (deviceCommunicationType === "LORAWAN") {
          deletePromise = ServerModensService.deleteLorawan(modem.id);
        } else {
          throw new Error("Tipo de comunicação inválido para exclusão de modem.");
        }
        await deletePromise

        modems.splice(index, 1);
        showSuccessSnackBar("Modem deletado com sucesso!")
        this.loadingModens = false
        this.FSM_Modem('set-modems', { modems })
      } catch (error) {
        console.error(error)
        const message = error?.response?.data?.message
        if (!message) showErrorSnackBar("Erro ao deletar modem!")
        this.loadingModens = false
      }

    },
    hasArguments(keys, params) {
      let keysNotFound = [];
      keys.forEach(key => {
        if (!params.hasOwnProperty(key)) keysNotFound.push(key);
      });
      let length = keysNotFound.length;
      if (length > 0) throw new TypeError(`A${length == 1 ? '' : 's'} chave${length == 1 ? '' : 's'} '${keysNotFound.join("', '")}' não fo${length == 1 ? 'i' : 'ram'} encontrada${length == 1 ? '' : 's'}`);
    },
    syncCommunicationTypeFields() {
      const type = this.getModemDeviceCommunicationType(this.modem);
      if (type === "LORA_GATEWAY") {
        if (this.modem.broker !== undefined) {
          this.$delete(this.modem, "broker");
        }
        this.$set(this.modem, "brokerSupply", "INTERNO");
      } else if (type === "LORAWAN" || type === "LTE") {
        if (this.modem.broker !== undefined) {
          this.$delete(this.modem, "broker");
        }
        if (!this.modem.brokerSupply) {
          this.$set(this.modem, "brokerSupply", "NLT");
        }
      } else {
        if (this.modem.brokerSupply !== undefined) {
          this.$delete(this.modem, "brokerSupply");
        }
        if (this.modem.broker !== undefined) {
          this.$delete(this.modem, "broker");
        }
      }
    },
    validateBrokerSupply(modem) {
      const type = this.getModemDeviceCommunicationType(modem);
      if (type !== "LORAWAN" && type !== "LTE") {
        return true;
      }
      return modem.brokerSupply === "NLT" || modem.brokerSupply === "PARLACOM";
    },
    validateLteModem(modem) {
      if (this.getModemDeviceCommunicationType(modem) !== "LTE") return true;
      const id = String(modem?.id ?? "").trim();
      return /^\d{15}$/.test(id);
    },
    lteImeiErrorMessage() {
      return "O IMEI do modem LTE deve conter exatamente 15 dígitos numéricos.";
    },
    validateLoraWanModemId(modem) {
      if (this.getModemDeviceCommunicationType(modem) !== "LORAWAN") return true;
      const id = String(modem?.id ?? "").trim();
      return id.length >= 16;
    },
    loraWanModemIdErrorMessage() {
      return "O ID do dispositivo LoRaWAN deve ter no mínimo 16 caracteres.";
    },
    validateLoraGatewayModemId(modem) {
      if (this.getModemDeviceCommunicationType(modem) !== "LORA_GATEWAY") return true;
      const id = String(modem?.id ?? "").trim();
      const expectedLength = this.isEditingModem ? 8 : 16;
      return new RegExp(`^[0-9A-Fa-f]{${expectedLength}}$`).test(id);
    },
    loraGatewayModemIdErrorMessage() {
      return this.isEditingModem
        ? "O ID do modem LoRa - Gateway deve conter 8 caracteres hexadecimais."
        : "O DevEUI do modem LoRa - Gateway deve conter exatamente 16 caracteres hexadecimais.";
    },
  },
  computed: {
    ...mapGetters([
      "getFranqueados",
      "getCurrentUser",
      "getCurrentUserRank",
      "getStatusCanDeletedDataAdmin",
    ]),
    ...mapState(['rank']),
    rulesName() {
      return Rules.string(true, 1, 64);
    },
    rulesRequired() {
      return Rules.required();
    },
    modemModelConnectionTypes() {
      return this.getConnectionTypesForSupplyOrigin(this.modemModel.supplyOrigin);
    },
    isModemModelSupplyOriginLocked() {
      return Boolean(this.modemModel.id) && Number(this.modemModel.quantity) > 0;
    },
    isModemModelConnectionTypeLocked() {
      return this.isModemModelSupplyOriginLocked;
    },
    modemModelSelectOptions() {
      if (!this.isEditingModem || !this.editingModemCommunicationType) {
        return this.models;
      }
      const allowedType = this.editingModemCommunicationType;
      return this.models.filter((item) => {
        const model = this.modemModels.find((modemModel) => modemModel.id === item.value);
        return model?.deviceCommunicationType === allowedType;
      });
    },
    selectedModemModel() {
      return this.getModemModelForModem(this.modem);
    },
    rulesModemId() {
      const rules = [...Rules.required()];
      const deviceCommunicationType = this.getModemDeviceCommunicationType(this.modem);
      if (deviceCommunicationType === "LORAWAN") {
        rules.push((value) => {
          if (!value) return true;
          return String(value).trim().length >= 16 || this.loraWanModemIdErrorMessage();
        });
      } else if (deviceCommunicationType === "LORA_GATEWAY") {
        rules.push((value) => {
          if (!value) return true;
          const expectedLength = this.isEditingModem ? 8 : 16;
          return new RegExp(`^[0-9A-Fa-f]{${expectedLength}}$`).test(String(value).trim())
            || this.loraGatewayModemIdErrorMessage();
        });
      }
      return rules;
    },
    rulesLteImei() {
      const rules = [...Rules.required()];
      rules.push((value) => {
        if (!value) return true;
        return /^\d{15}$/.test(String(value).trim()) || this.lteImeiErrorMessage();
      });
      return rules;
    },
    modemListener() {
      return this.modem
    },
    telemetryCountdownProgress() {
      if (!this.playTelemetryButton) return 0;
      return ((this.telemetryRefreshSeconds - this.telemetryCountdown) / this.telemetryRefreshSeconds) * 100;
    },
    telemetryStatusLabel() {
      switch (this.telemetryStatus) {
        case "refreshing":
          return "Atualizando agora";
        case "error":
          return "Tentando novamente";
        case "countdown":
          return `Próxima atualização em ${this.telemetryCountdown}s`;
        default:
          return "Pausado";
      }
    },
    telemetryStatusColor() {
      switch (this.telemetryStatus) {
        case "refreshing":
          return "primary";
        case "error":
          return "warning";
        case "countdown":
          return "success";
        default:
          return "grey";
      }
    },

    filteredItems() {
      let items = [];
      let search = "name"
      let busca = ""
      
      // Se não há texto de busca, retorna todos os modems
      if (!this.searchText || this.searchText.trim() === "") {
        return this.getModems;
      }
      
      switch (this.columnToSearch) {
        case "ID":
          search = 'id'
          items = this.getModems.filter((i) => {
            return (
              i[search].toLowerCase().indexOf(this.searchText.toLowerCase()) > -1
            );
          });
          break;
        case "Nome":
          search = 'name'
          items = this.getModems.filter((i) => {
            return (
              i[search].toLowerCase().indexOf(this.searchText.toLowerCase()) > -1
            );
          });
          break;
        case "Franqueado":
          search = "franchisee_name";
          items = this.getModems.filter((i) => {
            const value = i[search] || ""; // Garante que o valor é string ou vazio
            return value.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1;
          });
          break;
        case "Modelo":
          items = this.getModems.filter((i) => {
            const value = this.getModelo(i.model_id);
            return value.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1;
          });
          break;
        case "Bateria":
          search = 'last_battery'
          if (this.searchText === "") busca = 12
          else busca = (((this.searchText) / 100) * 12).toFixed(2)

          items = this.getModems.filter((i) => {
            let valueBatery = i[search] - 20
            if (valueBatery <= busca && valueBatery >= 0) return i
          });
          break;
        default:
          // Busca padrão por nome
          items = this.getModems.filter((i) => {
            return (
              i.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1
            );
          });
          break;
      }
      return items;
    },
    
    filteredActions() {
      if (this.getCurrentUserRank === "Franqueado") {
        return this.listActions.filter(action => action.value === "download");
      }
      return this.listActions;
    },
    filteredColumnsToChoose() {
      if (this.getCurrentUserRank === "Franqueado") {
        return this.columnsToChoose.filter(column => column !== "Franqueado");
      }
      return this.columnsToChoose;
    },
  },
  watch: {
    modalFlag(value) {
      if (value) return;

      this.clearTelemetryPolling();
      this.tabItems = ["Dados", "Alertas"];
      this.sectorCurrentModem = {};
      this.unitCurrentSector = {};
    },
  },
  beforeDestroy() {
    this.clearTelemetryPolling();
  },
  async mounted() {
    // Verifica o tipo de usuário:
    // se Admin, verifica se tem permissão pra deletar; se tiver, seta true; se não, seta false.
    // se Super Admin, seta true; se não, seta false.""

    await this.loadModemModels();

    if (this.getCurrentUserRank === "Franqueado") {
      this.franchiseeSelected = this.getCurrentUser.uid;
      this.canDeleted = false;
      this.canEdited = false;
      const response = await ServerModensService.findByFranchisee(this.franchiseeSelected);
      const rawModems = response?.data?.data || [];
      this.getModems = this.normalizeModemsCollection(rawModems);
      this.enrichModemsList();
      this.headers = this.headers.filter(header => header.value !== "franchisee_name");
      this.listActions = this.listActions.filter(action => action.value === "download");
      this.columnsToChoose = this.columnsToChoose.filter(column => column !== "Franqueado");
    } else if (this.getCurrentUserRank === "Admin" || this.getCurrentUserRank === "Super Admin") {
      this.canDeleted = true;
      this.canEdited = true;
      const response = await ServerModensService.findAll();
      const rawModems = response?.data?.data || [];
      this.getModems = this.normalizeModemsCollection(rawModems);
      await UsersServerService.findAllFranchisee()
        .then((res) => {
          this.listFranchisees = res?.data?.data || [];
          this.enrichModemsList();
        })
        .catch(() => {
          console.error("Erro ao buscar usuários.");
          showErrorSnackBar("Aconteceu um erro inesperado, contacte o suporte!")
        });
    }

    if (this.selectedItemProp) this.selectedItem = this.list.find(({ id_doc }) => id_doc === this.selectedItemProp)
    this.isLoadingData = false
    this.loadingModens = false
  },
};
